<template>
  <header>
    <div class="container flex">
      <a
        href="/"
        class="logo-container"
      >
        <img
          src="../../../images/logo.svg"
          alt="logo"
          class="logo"
        >
      </a>
      <VisitorNav
        v-if="role == 'visitor'"
        id="visitor-nav"
      />
      <div v-else>
        <LoggedInNavMenu
          v-if="role == 'user'"
          id="user-nav"
          :role="role"
          :picture="userPicture"
          :navlink="userNavLink"
          :dropdownmenu="userDropdownMenu"
          @logout="logout"
        />
        <LoggedInNavMenu
          v-else-if="role == 'lawyer'"
          id="lawyer-nav"
          :role="role"
          :picture="lawyerPicture"
          :navlink="lawyerNavLink"
          :dropdownmenu="lawyerDropdownMenu"
          @logout="logout"
        />
        <LoggedInNavMenu
          v-else-if="role == 'super_admin'"
          id="admin-nav"
          :role="role"
          :picture="adminPicture"
          :dropdownmenu="adminDropdownMenu"
          @logout="logout"
        />
        <LoggedInNavMenu
          v-else
          id="admin-nav"
          :role="role"
          :picture="adminPicture"
          :dropdownmenu="adminDropdownMenu"
          :show-notification="false"
          @logout="logout"
        />
      </div>
    </div>
  </header>
</template>

<script>
import {ref, onMounted, computed} from 'vue'
import VisitorNav from './VisitorNav.vue'
import {auth} from '@/api-services'
import LoggedInNavMenu from './LoggedInNavMenu.vue'
import userAvatar from '../../../images/user.svg'
import {useAuthStore, useServiceStore} from '@/store'

export default {
  name: 'NavHeader',
  components: {
    VisitorNav,
    LoggedInNavMenu,
  },
  setup() {
    const userId = ref('')
    const role = ref('')
    const adminPicture = ref(userAvatar)
    const lawyerPicture = ref(userAvatar)
    const userPicture = ref(userAvatar)

    const authStore = useAuthStore()
    const serviceStore = useServiceStore()

    const lawyerNavLink = [
        {
          name: 'Answer A Question',
          path: '/recently-asked-question',
        },
        {
          name: 'NRN Legal',
          path: '/nrn-service',
        },
    ]

    const lawyerDropdownMenu = [
        {
          name: 'Reviews',
          path: '/review',
        },
        {
          name: 'Dashboard',
          path: '/LawyerDashboard',
        },
        {
          name: 'Profile',
          path: '/lawyer-profile',
        },
    ]

    const adminDropdownMenu = [
        {
          name: 'Dashboard',
          path: '/MainDashboard',
        },
        {
          name: 'Settings',
          path: '/setting',
        },
    ]

    const userNavLink = [
        {
          name: 'My Questions',
          path: '/my-asked-question',
        },
        {
          name: 'NRN Legal',
          path: '/nrn-service',
        },
      ]

      const userDropdownMenu = [
        {
          name: 'Reviews',
          path: '/review',
        },
        {
          name: 'Review Lawyer',
          path: '/review/create',
        },
        {
          name: 'Settings',
          path: '/setting',
        },
    ]


    const logout = async () => {
      await authStore.logout()
    }

    onMounted(async () => {
      await serviceStore.getAllServices('query[category_eq]=local')
      if (window.$cookies.get('auth')) {
        await authStore.getAuthUser()
        const user = authStore.user
        role.value = user.role.name
        userId.value = user.id
        if (role.value === 'lawyer') {
          auth.getLawyer(userId.value).then((res) => {
            if (res.status == 200) {
              lawyerPicture.value = res.data[0].picture.url
            }
          })
        }
      } else {
        role.value = 'visitor'
      }
    })

    const topServices = computed(() => serviceStore.getThreeServices)

    return {
      role,
      adminPicture,
      lawyerPicture,
      userPicture,
      userDropdownMenu,
      userNavLink,
      adminDropdownMenu,
      lawyerDropdownMenu,
      lawyerNavLink,
      topServices,
      logout,
    }
  },
}
</script>
